import { SlideRecord } from "common/records/Slide";
import { RootState } from "common/reducers";
import { createSelector } from "reselect";

/**
 * Gets the slides by id map from state
 *
 * @param {RootState} state The RootState
 * @param {any} [_props] Optional props
 * @returns {Map<number, SlideRecord>} Map of slideId to slide
 */
export const byId = (state: RootState, _props?: any) => state.getIn(["slides", "byId"]);

/**
 * Gets a single slide by id
 *
 * @param {RootState} state The RootState
 * @param {{ slideId: number }} props
 * @returns {SlideRecord | undefined} The slide object or undefined
 */
export const slide = createSelector([byId, (_, props: { slideId: number }) => props.slideId], (slidesById, slideId) => {
  return slidesById.get(slideId);
});
